var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 23H1.25V4H24.2407V9.5",
    stroke: "#E53435",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94357 19H8.94357",
    stroke: "#E53435",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 24C24.0899 24 27 21.0899 27 17.5C27 13.9101 24.0899 11 20.5 11C16.9102 11 14 13.9101 14 17.5C14 21.0899 16.9102 24 20.5 24Z",
    stroke: "#E53435",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14149 14.3033C4.78394 14.1857 4.1912 13.2959 4 12.8006L5.27151 12.255C5.47228 12.6915 5.89293 13.0944 6.5717 13.0944C7.12619 13.0944 7.4608 12.8426 7.4608 12.4145C7.4608 11.2896 4.22945 11.4743 4.22945 9.36726C4.22945 8.37671 4.95602 7.66317 6.14149 7.52046V7H7.05927V7.53725C8.21606 7.71354 8.73231 8.51102 8.89484 8.93914L7.64245 9.43442C7.47992 9.12382 7.20268 8.72088 6.55258 8.72088C6.03633 8.72088 5.73996 8.98951 5.73996 9.35047C5.73996 10.4418 9 10.2823 9 12.3221C9 13.3295 8.28298 14.1018 7.06883 14.2781V15H6.14149V14.3033Z",
    fill: "#E53435"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.0498L18 20",
    stroke: "#E53435",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19.9502L18 15",
    stroke: "#E53435",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/payment_failed.57191b3512a046281d17b2593e442974.svg";
export { ForwardRef as ReactComponent };